export default {
    data() {
        return {
            customer: null,
            localCustomerName: "",
            localCustomerCountryCode: "+1",
            localCustomerPhone: "",
            customerLoggingIn: false,
            customerLoginErrorMessage: "",
            customer_phone_error: false,
            customer_name_error: false,
            gettingCustomer: false,
        };
    },
    methods: {
        customerLogin() {
            if (!this.localCustomerCountryCode || !this.localCustomerPhone) {
                this.customer_phone_error = true;
                return false;
            }
            if (!this.localReceiptEmail) {
                this.receipt_email_error = true;
                return false;
            }
            this.customerLoginErrorMessage = false;
            this.customer_phone_error = false;
            this.receipt_email_error = false;
            this.customerLoggingIn = true;
            axios
                .post("/api/customer/login", {
                    email: this.localReceiptEmail,
                    phone:
                        this.localCustomerCountryCode +
                        Number(this.localCustomerPhone),
                    user_id: this.rawMenu.user.id,
                })
                .then(
                    (response) => {
                        this.customerLoggingIn = false;
                        if (response.data.id) {
                            this.getCart();
                        }
                    },
                    (error) => {
                        this.customerLoginErrorMessage =
                            "No customer with the email " +
                            this.localReceiptEmail +
                            " and the phone " +
                            this.localCustomerCountryCode +
                            Number(this.localCustomerPhone) +
                            " was found. Sign up or try a different email or phone";
                        this.customerLoggingIn = false;
                    }
                );
        },
        customerSignUp() {
            if (!this.localCustomerCountryCode || !this.localCustomerPhone) {
                this.customer_phone_error = true;
                return false;
            }
            if (!this.localReceiptEmail) {
                this.receipt_email_error = true;
                return false;
            }

            if (!this.localCustomerName) {
                this.customer_name_error = true;
                return false;
            }

            this.customer_name_error = false;
            this.customerLoginErrorMessage = false;
            this.customer_phone_error = false;
            this.receipt_email_error = false;
            this.customerLoggingIn = true;
            axios
                .post("/api/customer/sign-up", {
                    email: this.localReceiptEmail,
                    phone:
                        this.localCustomerCountryCode +
                        Number(this.localCustomerPhone),
                    user_id: this.rawMenu.user.id,
                    name: this.localCustomerName,
                    email_consent: this.email_consent,
                })
                .then(
                    (response) => {
                        this.customerLoggingIn = false;
                        if (response.data.id) {
                            this.getCart();
                        }
                    },
                    (error) => {
                        this.customerLoginErrorMessage =
                            error.response.data.errors;
                        this.errors = error.response.data.errors;
                        this.customerLoggingIn = false;
                    }
                );
        },
        getCustomer() {
            this.gettingCustomer = true;
            axios
                .post("/api/customer/authenticated", {
                    user_id: this.rawMenu.user.id,
                })
                .then(
                    (response) => {
                        this.gettingCustomer = false;
                        if (response.data.id) {
                            this.customer = response.data;
                        }
                    },
                    (error) => {
                        this.gettingCustomer = false;
                    }
                );
        },
    },
};
